import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const two_speeching_bubbles: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={iconColor}
        d="M3.5,5.5 L15.5,5.5 L15.5,8.5 L15.5,11.5 L15.5,13.5 L15.5,14.5
    L9.5,14.5 L8.75,14.5 L6.5,16.75 L6.5,14.5 L3.5,14.5 L3.5,5.5 Z M6,8.5 L13,8.5 M6,10.5 L12,10.5
    M15.5,8.5 L20.5,8.5 L20.5,17.5 L17.5,17.5 L17.5,19.75 L15.25,17.5 L9.5,17.5 L9.5,14.5 M19,11.5
    L15.5,11.5 M18,13.5 L15.5,13.5"
      />
    </svg>
  );
};
